export default {
  setIntercom: (state, value) => (state.data = { ...state.data, ...value }),
  resetIntercom: (state) => (state.data = null)
}
